module.exports = __webpack_public_path__ + "img/Geerong.97893ce4.png";